// @flow

/**
 * Zona horaria en la que se pintan las fechas y las horas de los listados de contenidos.
 *
 * La de Finect, no la del proceso. El render de servidor corre en un contenedor en UTC y el
 * navegador en la zona del lector, así que si cada uno pinta en la suya, la hora de cada fila no
 * coincide al hidratar —dos horas de diferencia en verano, una en invierno— y React tira el HTML del
 * servidor para pintarlo todo otra vez. Medido el 2026-10-14 con el feed de noticias: las 20 filas
 * salían distintas. Con la zona fija, servidor y navegador pintan lo mismo.
 *
 * Se pasa como `timeZone` a `DateLabel`, y la usan también los tramos por día del feed.
 */
export const SITE_TIME_ZONE = 'Europe/Madrid';

const siteDayFormat = new Intl.DateTimeFormat('en-US', {
  timeZone: SITE_TIME_ZONE,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
});

/**
 * Año, mes (de 0 a 11, como `Date`) y día de una fecha en la zona de Finect.
 *
 * @param date Fecha
 */
export const getSiteDateParts = (date: Date): { year: number, month: number, day: number } => {
  const parts = {};

  siteDayFormat.formatToParts(date).forEach(({ type, value }) => {
    parts[type] = Number(value);
  });

  return { year: parts.year, month: parts.month - 1, day: parts.day };
};
